import { withTheme } from 'styled-components'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'
import ProgramCard from './component.jsx'

export default withSiteContext(withTheme(ProgramCard))
